module.exports = void 0



// WEBPACK FOOTER //
// ./src/base/void.js